import React, {useEffect, useRef, useState} from 'react';
import {Col, Form, Row, Tabs, message, Badge, Spin} from 'antd';
import ProForm, {ProFormInstance} from '@ant-design/pro-form';
import {FileUploadUtility, WdiFileList} from '@/components/WdiControls/WdiFileUpload';
import TabPane from '@ant-design/pro-card/lib/components/TabPane';
import DynamicInformation from '../../components/DynamicInformation';
import BudgetInformation from '../../components/BudgetInformation';
import {FormPageProps, WdiFormPageTitle} from '@/components/WdiBus/FormPage';
import {getFormStatusName, initApprovalPageContext, ViewEntityProps} from '../../components/data';
import {ResponseStatus} from '@/utils/request';
import DataStore from '@/components/GridWidget/DataStore';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {WdiCardTitle, wdiCore, WdiInput, WdiStaffCard} from '@/components/WdiControls';
import {FormSADetailsForApprovalPanel} from '../../FreeGoodsApply/components/details';
import {EC} from '@/services/mdm/ec';
import {Enum} from '@/enums/system';
import {ProjectToolTipApp} from '../../components/ProjectCmpt';
import {FormSaDetail} from '@/services/sales/sa';
import {SAWarningApprovalApp} from '../../components/WarningInformation';
import {FormSa} from '@/services/sales/sa';
import {SalesAndCostRegion, SalesAndCostSoldTo} from "@/pages/sales/sa/components/SalesAndCost";
import {WdiEditor} from "@/components/WdiControls/WdiEditor";

const moreConfig: any = {
  successParams: [
    {
      url: "/basicapi/favorite/getButtons",
      keys: []
    }, {
      url: "/expenseapi/saButtons/get",
      keys: [
        "UndoButton",
        "ReeditButton",
        "CancelButton",
        "CopyButton",
        "InterveneFlowButton",
        "AppendExtNodeButton",
        "TransferNodeButton",
        "ClosedButton",
        "AddMailApproverButton",
        "FormSpPrintButton",
        "ExpediteFlowButton",
      ]
    }
  ],
  errorParams: [
    {
      url: "/expenseapi/saButtons/get",
      keys: [
        "RepairButton",
        "InterveneFlowButton"
      ]
    }
  ]
};
const approvalConfig: any = {
  params: {
    url: "/expenseapi/saButtons/get",
    keys: [
      "ApprovalButton",
      "ReadButton",
    ]
  }
};

const FGActivityApprovalApp: React.FC<FormPageProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [dataSource, setDataSource] = useState<any[]>([]);
  const [warningCount, setWarningCount] = useState<number>(0);
  const [entity, setEntity] = useState<ViewEntityProps>();
  const [activeKey, setActiveKey] = useState<string>("1");
  useEffect(() => {
    if (!formRef?.current) {
      return;
    }
    setActiveKey(props.data?.defaultActiveKey ?? "1");
  }, [(!!formRef?.current)])

  const onDetailsChange = (data: any) => {
    setDataSource(DataStore.init(data));
  };

  useEffect(() => {
    (async () => {
      const params = props.data;
      if (params) {
        const result = await initApprovalPageContext(params);
        if (result.code !== ResponseStatus.SUCCESS) {
          message.error(result.message);
          return;
        }
        const viewEntity: ViewEntityProps = result.data;

        if (viewEntity.formSa) {
          formRef.current?.setFieldsValue({
            activityName: viewEntity.formSa?.activityName,
            activityDate: wdiCore.Date.Join(viewEntity.formSa?.activityStartDate, viewEntity.formSa?.activityEndDate),
            fileInfo: FileUploadUtility.parse(viewEntity.formSa?.fileName, viewEntity.formSa?.filePath),
            remark: viewEntity.formSa?.remark,
            project: viewEntity.budgetProject,
          });

          const formSaId = viewEntity.formSa?.formSaId ?? 0;
          FormSa.Buttons.countOfWarning(formSaId).then(response => {
            setWarningCount(response.data);
          });
          FormSaDetail.getFgEx(formSaId).then((response) => {
            setDataSource(DataStore.init(response.data));
            if (response && response.data.length > 0) {
              EC.get(Number(response.data[0].ecId)).then((response) => {
                formRef.current?.setFieldsValue({
                  ecName: response.data.ecName
                });
              });
            }
          });
        }
        setEntity(viewEntity);
      }
    })();
  }, [props.data]);

  useEffect(() => {
    if (props.setPageTitle && entity) {
      let title = `免费货活动申请单【${entity.form?.formNo}】`;


      getFormStatusName(entity).then(result => {
        title += `，${result}`;
        if (props.setPageTitle) props.setPageTitle(
          <WdiFormPageTitle
            title={title}
            onClose={props.onClose}
            callback={props.callback}
            form={entity?.form}
            useCaseId={Enum.UseCase.SA}
            moreConfig={moreConfig}
            approvalConfig={approvalConfig}/>
        );
      });
    }
  }, [props.setPageTitle, entity]);

  return (
    <>
      <WdiStaffCard formId={entity?.form?.formId}/>
      <Tabs activeKey={activeKey} onTabClick={(key, _) => setActiveKey(key)} size="large">
        <TabPane tab={<span>活动信息</span>} key="1">
          <ProForm
            formRef={formRef}
            submitter={{
              render: () => {
                return (<></>)
              },
            }}
          >
            <WdiPanel title={<WdiCardTitle iconType={Enum.IconType.BASE_INFO} title='活动基本信息'/>} collapsed={true}>
              <Row gutter={[16, 24]}>
                <Col className="gutter-row" span={8}>
                  <Form.Item name="activityName" label="活动名称">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="activityDate" label="活动期间">
                    <WdiInput readOnly/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={4}>
                  <Form.Item name="project" label="专项项目">
                    <ProjectToolTipApp/>
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={[16, 24]}>
                <Col className="gutter-row" span={16}>
                  <Form.Item name="remark" label="方案简述">
                    <WdiEditor readOnly={true}/>
                  </Form.Item>
                </Col>
                <Col className="gutter-row" span={8}>
                  <Form.Item
                    name="fileInfo"
                    label="附件"
                    valuePropName='fileList'
                    getValueFromEvent={(e: any) => {
                      return e.fileList || [];
                    }}
                  >
                    <WdiFileList
                      fileList={FileUploadUtility.parse(entity?.formSa?.fileName, entity?.formSa?.filePath)}/>
                  </Form.Item>
                </Col>
              </Row>
            </WdiPanel>
          </ProForm>
          <FormSADetailsForApprovalPanel dataSource={dataSource} pid={props.data?.formId} onChange={onDetailsChange}/>
        </TabPane>
        <TabPane tab={<span>预算信息</span>} key="2">
          <BudgetInformation formId={entity?.form?.formId}/>
        </TabPane>
        {entity?.boLevelSoldToOpts && entity.boLevelSoldToOpts.length > 0 && (
          <TabPane tab={<span>销量与费用(客户)</span>} key="3-1">
            <SalesAndCostSoldTo
              formSa={entity?.formSa}
              formSaDetails={dataSource}
              boLevelOpts={entity?.boLevelSoldToOpts}
            />
          </TabPane>
        )}
        {entity?.boLevelRegionOpts && entity?.boLevelRegionOpts.length > 0 && (
          <TabPane tab={<span>销量与费用(区域)</span>} key="3-2">
            <SalesAndCostRegion
              formSa={entity?.formSa}
              formSaDetails={dataSource}
              boLevelOpts={entity?.boLevelRegionOpts}
            />
          </TabPane>
        )}
        <TabPane tab={<><span>警示信息</span>
          <Badge
            count={warningCount}
            style={{
              color: "black",
              boxShadow: "none",
              background: "none",
              top: "-20px",
              right: "-15px",
              position: 'absolute'
            }}>
          </Badge></>
        } key="4">
          <SAWarningApprovalApp formId={entity?.form?.formId}/>
        </TabPane>
        <TabPane tab={<span>动态信息</span>} key="5">
          {
            entity?.form ? <DynamicInformation
              formId={entity?.form?.formId}
              formTypeId={entity?.form?.formTypeId}
              pageTypeId={entity?.form?.pageTypeId}
              useCaseId={Enum.UseCase.SA}
            /> : <Spin/>
          }
        </TabPane>
      </Tabs>
    </>
  );
};
export default FGActivityApprovalApp;
